import React, { Component } from 'react'
import { object, string } from 'prop-types'

class CommonInfo extends Component {
  render () {
    const {
      productData: {
        sellingpoint = '',
        seo_information: seoInformation = '',
        parken = '',
        transfer = '',
        fruehstuecksinformationen = '',
        kinderangebot = '',
        zimmerausstattung = '',
        freizeiteinrichtung = '',
        anreise = '',
        abreise = '',
        adresse = ''
      },
      productPrice
    } = this.props

    return (
      <React.Fragment key='info'>
        {productPrice && (
          <p>
            Ab
            <span className='priceSpan'>&euro; {productPrice}</span> pro
            Doppelzimmer
          </p>
        )}

        {sellingpoint && <p className='sellingpoint'>{sellingpoint}</p>}

        {seoInformation && (
          <p dangerouslySetInnerHTML={{ __html: seoInformation }} />
        )}

        {parken && [
          <h2 key='0'>Parken:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: parken }} />
        ]}

        {transfer && [
          <h2 key='0'>Transfer:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: transfer }} />
        ]}

        {fruehstuecksinformationen && [
          <h2 key='0'>Fr&uuml;hst&uuml;ck:</h2>,
          <p
            key='1'
            dangerouslySetInnerHTML={{ __html: fruehstuecksinformationen }}
          />
        ]}

        {kinderangebot && [
          <h2 key='0'>Kinderregelung:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: kinderangebot }} />
        ]}

        {zimmerausstattung && [
          <h2 key='0'>Zimmerausstattung:</h2>,
          <p key='1' dangerouslySetInnerHTML={{ __html: zimmerausstattung }} />
        ]}

        {freizeiteinrichtung && [
          <h2 key='0'>Freizeitangebot:</h2>,
          <p
            key='1'
            dangerouslySetInnerHTML={{ __html: freizeiteinrichtung }}
          />
        ]}

        {anreise && abreise && [
          <h2 key='0'>Check-In &amp; Check-Out:</h2>,
          <p key='1'>
            {anreise} - {abreise}
          </p>
        ]}

        {adresse && [<h2 key='0'>Anschrift:</h2>, <p key='1'>adresse</p>]}
      </React.Fragment>
    )
  }
}

CommonInfo.propTypes = {
  productInfo: object.isRequired,
  productPrice: string.isRequired
}

export default CommonInfo



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/de/commonInfo.jsx